import * as React from "react";
import {
    Show,
    SimpleShowLayout,
    TextField,
    DateField,
    TopToolbar,
} from "react-admin";
import ValidateButton from "./ValidateButton";
import RejectButton from "./RejectButton";
import StatusField from "../../components/StatusField";

export default function SubjectShow() {
    return (
        <Show
            actions={
                <TopToolbar>
                    <ValidateButton />
                    <RejectButton />
                </TopToolbar>
            }
        >
            <SimpleShowLayout>
                {/* Identifiants */}
                <TextField source="id" />
                <TextField source="subjectId" />

                {/* Données */}
                <TextField source="subject" />
                <TextField source="shortSubject" />
                <TextField source="username" label="Auteur" />

                {/* Statut */}
                <StatusField />

                {/* Dates principales */}
                <DateField source="createdAt" showTime />

                {/* Validation */}
                <DateField source="validatedAt" showTime />
                <TextField source="validatedBy" />

                {/* Rejet */}
                <DateField source="rejectedAt" showTime />
                <TextField source="rejectedBy" />
            </SimpleShowLayout>
        </Show>
    );
}
